"use client"

import { useEffect, useState } from "react"
import CommonAuthLayout from "../common/common-auth-layout/CommonAuthLayout"
import "./CongratulationsPage.css"

const CongratulationsPage = ({ onComplete }) => {
  const [isWaiting, setIsWaiting] = useState(true)

  useEffect(() => {
    const doneTimer = setTimeout(() => {
      setIsWaiting(false)
      onComplete()
    }, 2500)

    return () => clearTimeout(doneTimer)
  }, [onComplete])

  return (
    <CommonAuthLayout showTitle={false}>
      <div className="congratulations-page-inner">
        <div className="congratulations-card">
          <div className="checkmark-icon">
            <img src="/assets/icons/common/green-check.svg" alt="" />
          </div>

          <h1 className="congratulations-title">Congratulations, your account is ready!</h1>

          <p className="congratulations-text">
            We&apos;re now pulling in your hotel information.
            <br />
            Our AI-powered system will show you the possibilities
            <br />
            for creating engaging social media content.
          </p>

          <div className="congratulations-wait">
            <p className="congratulations-subtext">This may take a few moments...</p>
            {isWaiting && (
              <div className="loading-dots" aria-hidden="true">
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
          </div>
        </div>
      </div>
    </CommonAuthLayout>
  )
}

export default CongratulationsPage
